function Localization() {
    this.localization = window.localizationKeys;
}
window.Localization = new Localization();

/**
 * Returns the sum of a and b
 * @param {string} key
 * @returns {string}
 */
Localization.prototype.getText = function(key) {
    var value = this.localization.text[key];

    if (value === undefined) {
        console.log("mangler key", key)
        return "BLANK";
    }

    return value;
};



//////////////////
// WEBPACK FOOTER
// ./Content/scripts/LocalizationUtil.js
// module id = 0
// module chunks = 0